var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html, css } from "lit";
import { property } from "lit/decorators.js";
import { customElement, PICBase, labelDecoder, stringDecoder, numberDecoder, booleanDecoder, stringDecoderLC } from "../Internals";
import { isBlackColor } from "../../util/SvgColor";
let PICLabel = class PICLabel extends PICBase {
    constructor() {
        super();
        this.label_ = '';
        this.density = 'old';
    }
    connectedCallback() {
        super.connectedCallback();
    }
    addCMDListeners() {
        //super.addCMDListeners(); //left intentionally, currently only supports update
        this.addEventListener('update', this.handleCMDUpdate.bind(this));
    }
    removeCMDListeners() {
        //super.removeCMDListeners(); //left intentionally, currently only supports update
        this.removeEventListener('update', this.handleCMDUpdate.bind(this));
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                margin-left: 2px;
                margin-right: 2px;
                display: inline-block;
            }
            .new{
                font-family: 'Montserrat';
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
        return;
    }
    validateSubmit() {
        return true;
    }
    get submitValue() {
        return null;
    }
    getLblStyle() {
        let styles = [];
        styles.push({ 'text-align': this.justification_ ? this.justification_ : '' });
        styles.push({ 'font-size': this.size_ ? this.size_ + 'rem;' : '.75rem' });
        styles.push({ 'color': this.color_ && !isBlackColor(this.color_) ? this.color_ : 'var(--pic-onSurfaceHighColor)' });
        styles.push({ 'white-space': this.whitespace ? this.whitespace : '' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getLblClass() {
        return {
            'tabelement': true,
            'new': this.eType_ == 'default',
            'old': this.eType_ !== 'default',
        };
    }
    handleCMDUpdate(e) {
        var _a;
        let cmd = e.detail;
        if (e.detail.data)
            cmd = e.detail.data;
        let labelData;
        if (typeof cmd === 'string') {
            labelData = cmd;
        }
        else if ((_a = e.detail.data) === null || _a === void 0 ? void 0 : _a.label) {
            labelData = e.detail.data.label;
        }
        else {
            throw new Error('Failed to decode label');
        }
        const decoded = labelDecoder(labelData);
        if (typeof decoded !== 'string') {
            this.label_ = html `${unsafeHTML(`${labelData}`)}`;
        }
        else
            this.label_ = labelData;
        this.requestUpdate();
    }
    render() {
        return html `
        ${this.renderCSS(true)}
        <div class=${classMap(this.getLblClass())} style=${styleMap(this.getLblStyle())}>
            ${typeof this.label_ === 'string'
            && this.label_.indexOf('data-html="true"') > -1
            && this.label_.indexOf('</script>') === -1
            ?
                html `<label>${unsafeHTML(`${this.label_}`)}</label>`
            :
                html `<label>${this.bold_ ? html `<strong>${this.label_}</strong>` : this.label_}</label>`}
        </div>
        `;
    }
};
__decorate([
    property({ converter: labelDecoder, attribute: 'label' })
], PICLabel.prototype, "label_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'justification' })
], PICLabel.prototype, "justification_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'color' })
], PICLabel.prototype, "color_", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'size' })
], PICLabel.prototype, "size_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'bold' })
], PICLabel.prototype, "bold_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'etype' })
], PICLabel.prototype, "eType_", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'density' })
], PICLabel.prototype, "density", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'whitespace' })
], PICLabel.prototype, "whitespace", void 0);
PICLabel = __decorate([
    customElement('pic-label')
], PICLabel);
export { PICLabel };
//# sourceMappingURL=PICLabel.js.map